import React, { useEffect, useState } from 'react'
import client from '../../client/Client'
import HeaderBanner from '../ui/HeaderBanner'
import { Card, CardBody, CardHeader, Typography } from '@material-tailwind/react'

interface Content {
  name: string,
  url?: string,
  image: {
    asset: {
      _ref: string
    }
  }
}

const Sponsors = () => {
  const [FinancialSponsors, setFinancialSponsors] = useState<Content[]>([])
  const [TechnicalSPonsors, setTechnicalSPonsors] = useState<Content[]>([])

  useEffect(() => {
    client.fetch('*[_type == "Sponsors"]')
      .then((result) => {
        setFinancialSponsors(result[0].FinancialSponsors);
        setTechnicalSPonsors(result[0].TechnicalSponsors);
      })
      .catch((error) => {
        console.error('Error fetching FinancialSponsors:', error);
      });
  }, [])

  return (
    <>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-32">
        <div
          className="fixed left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none -z-1"
          aria-hidden="true"
        >
          <svg width="1360" height="578" viewBox="0 0 1360 578" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="illustration-01">
                <stop stopColor="#FFF" offset="0%" />
                <stop stopColor="#EAEAEA" offset="77.402%" />
                <stop stopColor="#DFDFDF" offset="100%" />
              </linearGradient>
            </defs>
            <g fill="url(#illustration-01)" fillRule="evenodd">
              <circle cx="1232" cy="128" r="128" />
              <circle cx="155" cy="443" r="64" />
            </g>
          </svg>
        </div>

        <HeaderBanner title='Sponsors' />

        <div className="grid gap-4">
          {/* TECHNICAL SPONSORS */}
          <h1 className="text-2xl text-red-600 font-semibold">Technical Sponsors:</h1>

          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-8">
            {TechnicalSPonsors?.map((item) => (
              <Card
                key={item.name}
                className="bg-white shadow-md rounded-xl hover:shadow-lg transition-transform transform hover:-translate-y-1 flex flex-col h-72"
              >
                <CardHeader floated={false} className="h-40 overflow-hidden">
                  {item.image?.asset && (
                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                      <img
                        className="object-contain h-full w-full p-2"
                        src={`https://cdn.sanity.io/images/79vgbaej/production/${
                          item.image.asset._ref.slice(6, -4) + '.' + item.image.asset._ref.slice(-3)
                        }`}
                        alt="sponsor logo"
                      />
                    </a>
                  )}
                </CardHeader>
                <CardBody className="flex-1 flex items-center justify-center text-center">
                  <Typography color="blue-gray" className="font-medium" textGradient>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-901 hover:text-blue-902 text-sm sm:text-base font-semibold transition-colors"
                    >
                      {item.name}
                    </a>
                  </Typography>
                </CardBody>
              </Card>
            ))}
          </div>

          {/* FINANCIAL SPONSORS */}
          <h1 className="text-2xl text-red-600 font-semibold">Financial Sponsors:</h1>

          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-8">
            {FinancialSponsors?.map((item) => (
              <Card
                key={item.name}
                className="bg-white shadow-md rounded-xl hover:shadow-lg transition-transform transform hover:-translate-y-1 flex flex-col h-72"
              >
                <CardHeader floated={false} className="h-40 overflow-hidden">
                  {item.image?.asset && (
                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                      <img
                        className="object-contain h-full w-full p-2"
                        src={`https://cdn.sanity.io/images/79vgbaej/production/${
                          item.image.asset._ref.slice(6, -4) + '.' + item.image.asset._ref.slice(-3)
                        }`}
                        alt="sponsor logo"
                      />
                    </a>
                  )}
                </CardHeader>
                <CardBody className="flex-1 flex items-center justify-center text-center">
                  <Typography color="blue-gray" className="font-medium" textGradient>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-901 hover:text-blue-902 text-sm sm:text-base font-semibold transition-colors"
                    >
                      {item.name}
                    </a>
                  </Typography>
                </CardBody>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Sponsors
